var map = {
	"./information_swallow.mp4": "62ca",
	"./information_swallow_mix.mp4": "e25e",
	"./information_swallow_new.mp4": "2649",
	"./information_swallow_recent.mp4": "8e0f",
	"./information_tongue.mp4": "464c",
	"./swallow_practice_mix.mp4": "d11b",
	"./swallow_practice_new.mp4": "186f",
	"./swallow_split_mix.mp4": "278d",
	"./swallow_split_new.mp4": "9ad6",
	"./swallow_split_new_light.mp4": "d881",
	"./swallow_split_origin.mp4": "cca3",
	"./swallow_water_mix.mp4": "9154",
	"./swallow_water_new.mp4": "ba9d",
	"./swallow_water_new_light.mp4": "9cff",
	"./swallow_water_origin.mp4": "ad97",
	"./tongue_practice.mp4": "9c6c",
	"./tongue_practice_light.mp4": "f81c",
	"./tongue_training.mp4": "3e7a",
	"./tongue_training_light.mp4": "202a",
	"./videoSample1.mp4": "a89c",
	"./videoSample2.mp4": "2c98"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a9f";